import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const AdoptionCountrySchema = z.object({ destinationCountryCode: z.string() });

const AdoptionGroupSchema = z.object({
  markup: z.number(),
  hasFixedPriceOverrides: z.boolean(),
  countries: z.array(AdoptionCountrySchema),
});

export const previewShopifyMarketAdoption = {
  name: "previewShopifyMarketAdoption" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    totalShopifyMarkets: z.number(),
    homeCountryCode: z.string(),
    groups: z.array(AdoptionGroupSchema),
    alreadyAdoptedCount: z.number(),
    skippedMultiCountry: z.array(
      z.object({ handle: z.string(), countryCodes: z.array(z.string()) }),
    ),
    skippedHomeCountry: z.array(
      z.object({ handle: z.string(), countryCodes: z.array(z.string()) }),
    ),
  }),
};
